import React from 'react'
import { router } from '@inertiajs/react'

function AssignSection({ polo, possibleResponsibles }) {
  const handleSet = (userId, task, assignFor) => {
    router.post('/responsibilities/bulk_set', {
      responsibility: {
        polo_id: polo.id,
        user_id: userId,
        task: task,
        for: assignFor,
      },
    }, {
      preserveScroll: true,
      forceFormData: true,
    })
  }

  return (
    <div className="mt-4 pt-4 border-t border-gray-200">
      <h4 className="font-semibold text-gray-700 mb-2">Atribuir</h4>
      {possibleResponsibles.length === 0 ? (
        <p className="text-gray-500 italic ml-4">Não há mais alunos para atribuir</p>
      ) : (
        <ul className="ml-4 space-y-3">
          {possibleResponsibles.map(user => (
            <li key={user.id}>
              <span className="font-medium block mb-1">{user.full_name}</span>
              <div className="flex gap-2 text-sm">
                <button
                  type="button"
                  onClick={() => handleSet(user.id, 'editor', 'both')}
                  className="text-brand-light hover:text-brand-dark hover:underline"
                >
                  Polo, quadra e lotes
                </button>
                <span className="text-gray-400">|</span>
                <button
                  type="button"
                  onClick={() => handleSet(user.id, 'revisor', 'revisor')}
                  className="text-brand-light hover:text-brand-dark hover:underline"
                >
                  Revisão
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

function UserList({ title, users, emptyMessage, poloId, canEdit = false }) {
  const handleUnset = (responsibilityIds) => {
    router.post('/responsibilities/bulk_unset', {
      responsibility: { ids: responsibilityIds },
    }, {
      preserveScroll: true,
      forceFormData: true,
    })
  }

  return (
    <div className="mb-4">
      <h4 className="font-semibold text-gray-700 mb-2">{title}</h4>
      {users.length === 0 ? (
        <p className="text-gray-500 italic ml-4">{emptyMessage}</p>
      ) : (
        <ul className="ml-4 space-y-1">
          {users.map(user => (
            <li key={user.id} className="flex items-center gap-2">
              <span className="font-medium">{user.full_name}</span>
              {canEdit && user.responsibility_ids?.length > 0 && (
                <button
                  type="button"
                  onClick={() => handleUnset(user.responsibility_ids)}
                  className="text-red-600 text-sm hover:underline"
                >
                  Isentar
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default function ResponsibilitySection({
  polo,
  responsibles = [],
  lotesResponsibles = [],
  revisors = [],
  possibleResponsibles = [],
  isAdmin = false,
  className = ''
}) {
  return (
    <div className={`mt-6 bg-white border border-gray-200 rounded-lg p-6 ${className}`}>
      <h2 className="text-xl font-bold text-brand-dark mb-4">Responsáveis</h2>

      <UserList
        title="Polo e suas quadras"
        users={responsibles}
        emptyMessage="Ainda não há responsáveis pelo polo"
        poloId={polo.id}
        canEdit={isAdmin}
      />

      <UserList
        title="Lotes"
        users={lotesResponsibles}
        emptyMessage="Ainda não há responsáveis por seus lotes"
        poloId={polo.id}
        canEdit={isAdmin}
      />

      <UserList
        title="Revisão"
        users={revisors}
        emptyMessage="Ainda não há responsáveis pela revisão"
        poloId={polo.id}
        canEdit={isAdmin}
      />

      {/* Assign section - Admin only */}
      {isAdmin && (
        <AssignSection polo={polo} possibleResponsibles={possibleResponsibles} />
      )}
    </div>
  )
}
